<div class='teeth-main' data-cy="teeth-canals-container">
  <mat-progress-spinner *ngIf="!cfgTeeth" style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)" diameter="100" mode="indeterminate" data-cy="teeth-canals-loading-spinner"></mat-progress-spinner>
  <mat-grid-list *ngIf="cfgTeeth" cols="6" rowHeight="100%" style="height:100%;" data-cy="teeth-canals-grid">
    <mat-grid-tile colspan="2" data-cy="teeth-canals-list-tile">
      <mat-card appearance="outlined" style="width:100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="teeth-canals-list-card">
        <span class="configuration-section-title" data-cy="teeth-canals-list-title">Teeth</span>
        <div style="flex: 1; max-height: 100%; overflow-y: hidden;" data-cy="teeth-canals-list-content">
          <tdo-table *ngIf="cfgTeeth" sortActive="ToothId" sortDirection="asc" [isAutoSelectFirstItem]="true" (rowSelected)="onRowSelected($event)" #toothTable [dataSource]="cfgTeeth" [isSearchable]="false" data-cy="teeth-canals-table">
            <tdo-table-column displayName="Tooth #" propertyName="ToothId" [rowTemplate]="tooth" data-cy="teeth-canals-tooth-column">
              <ng-template #tooth let-row>
                <div data-cy="teeth-canals-tooth-{{getToothNum(row.ToothId)}}">{{getToothNum(row.ToothId)}}</div>
              </ng-template>
            </tdo-table-column>
          </tdo-table>
          <!--<app-tdo-table [sortActive]="true" [isSearchable]="false" *ngIf="tableModel !== undefined" [tdoTableModel]="tableModel" (actionClick)="onTdoTableItemActionClick($event)" (itemSelected)="onTdoTableItemClick($event)"></app-tdo-table>-->
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="selectedTooth" colspan="4" data-cy="teeth-canals-detail-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" *ngIf="selectedTooth" data-cy="teeth-canals-detail-card">
        <mat-card-content data-cy="teeth-canals-detail-content">
          <div style="max-width: 700px;" data-cy="teeth-canals-detail-container">
            <span class="configuration-section-title" data-cy="teeth-canals-detail-title">Teeth Canals and Surfaces</span>
            <app-tdo-configuration-action-bar
              [showCancel]="!saveDisabled"
              [newHidden]="true"
              [showAdd]="false"
              (saveClick)="onSave($event)"
              (cancelClick)="onCancel($event)"
              (editClick)="onEdit($event)"
              data-cy="teeth-canals-action-bar">
            </app-tdo-configuration-action-bar>

            <div style="padding-bottom: 20px" data-cy="teeth-canals-selected-tooth-header">
              <span class="configuration-section-title" data-cy="teeth-canals-selected-tooth-label">Tooth: #{{ selectedTooth.cfgToothDescriptions[0].Notation }}</span>
            </div>

            <mat-tab-group style="height: 600px;" mat-align-tabs="start" (selectedTabChange)="onTabChange($event)" data-cy="teeth-canals-tabs">
              <mat-tab style="height: 100%; overflow-y: hidden;" label="Canals" data-cy="teeth-canals-canals-tab">

                <div style="flex: 1; overflow-y: auto; height: 300px; margin-top: 10px;" data-cy="teeth-canals-canals-container">

                <tdo-table #canalTable [dataSource]="this.selectedTooth.cfgToothCanals"
                           [isMultiSelection]="true" [isSearchable]="false"
                           (rowSelected)="onRowSelectedCanal($event)"
                           data-cy="teeth-canals-canals-table">
                  <tdo-table-column displayName="Order" propertyName="Order" [rowTemplate]="order" data-cy="teeth-canals-order-column">
                    <ng-template #order let-row>

                        <mat-form-field class="dropdown-list" floatLabel="never" style="width:75px" data-cy="teeth-canals-order-field-{{row.index}}">
                          <mat-label data-cy="teeth-canals-order-label-{{row.index}}">Order</mat-label>
                          <mat-select [(value)]="row.model.CanalOrder" (selectionChange)="onChangeCanalOrder($event); configurationService.setDirty();" data-cy="teeth-canals-order-select-{{row.index}}">
                            <mat-option *ngFor="let item of numArraySelectedCanal" [value]="item" data-cy="teeth-canals-order-option-{{item}}">
                              {{ item }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                    </ng-template>
                  </tdo-table-column>
                  <tdo-table-column displayName="Canal" propertyName="ToothCanalId" isSortable="true" [rowTemplate]="canal" data-cy="teeth-canals-canal-column">
                    <ng-template #canal let-row>
                      <div *ngIf="row.model.enumToothCanalID" data-cy="teeth-canals-canal-container-{{row.index}}">

                        <mat-form-field class="dropdown-list" floatLabel="never" data-cy="teeth-canals-canal-field-{{row.index}}">
                          <mat-label data-cy="teeth-canals-canal-label-{{row.index}}">Canal</mat-label>
                          <mat-select [(value)]="row.model.enumToothCanalID" (selectionChange)="onChangeCanal($event); configurationService.setDirty();" data-cy="teeth-canals-canal-select-{{row.index}}">
                            <mat-option *ngFor="let enum of enumCanals" [value]="enum.ValidValueItemId" data-cy="teeth-canals-canal-option-{{enum.ValidValueItemId}}">
                              {{ enum.ItemDisplayValue }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                      </div>
                    </ng-template>
                  </tdo-table-column>
                  <tdo-table-column displayName="" propertyName="Remove" [rowTemplate]="code" data-cy="teeth-canals-remove-column">
                    <ng-template #code let-row>
                      <div *ngIf="row.model.enumToothCanalID" style="text-align: right;" data-cy="teeth-canals-remove-container-{{row.index}}">
                        <button style="color: var(--tdo-secondary);" mat-icon-button [matTooltip]="'Remove Canal'" (click)="row.model.isDelete = true; removeCanal(row.model.ToothCanalId)" data-cy="teeth-canals-remove-button-{{row.index}}"><mat-icon>delete</mat-icon></button>
                      </div>
                    </ng-template>
                  </tdo-table-column>
                </tdo-table>

                </div>

                <button class="tdo-button tdo-save" style="margin-top:15px"
                        (click)="addCanal()" data-cy="teeth-canals-add-canal-button">Add Canal</button>

              </mat-tab>
              <mat-tab label="Surfaces" data-cy="teeth-canals-surfaces-tab">

                <div style="flex: 1; overflow-y: auto; height: 300px; margin-top: 10px;" data-cy="teeth-canals-surfaces-container">

                  <tdo-table #surfaceTable [dataSource]="this.selectedTooth.cfgToothSurfaces"
                             [isMultiSelection]="true" [isSearchable]="false"
                             (rowSelected)="onRowSelectedSurface($event)"
                             data-cy="teeth-canals-surfaces-table">
                    <tdo-table-column displayName="Order" propertyName="SegmentOrder" [rowTemplate]="order1" data-cy="teeth-canals-surface-order-column">
                      <ng-template #order1 let-row>

                          <mat-form-field class="dropdown-list" floatLabel="never" style="width:75px" data-cy="teeth-canals-surface-order-field-{{row.index}}">
                            <mat-label data-cy="teeth-canals-surface-order-label-{{row.index}}">Order</mat-label>
                            <mat-select [(value)]="row.model.SegmentOrder" (selectionChange)="onChangeSurfaceOrder($event); configurationService.setDirty();" data-cy="teeth-canals-surface-order-select-{{row.index}}">
                              <mat-option *ngFor="let item of numArraySelectedSurface" [value]="item" data-cy="teeth-canals-surface-order-option-{{item}}">
                                {{ item }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>

                      </ng-template>
                    </tdo-table-column>
                    <tdo-table-column displayName="Surface" propertyName="ToothSurfaceId" isSortable="true" [rowTemplate]="surface" data-cy="teeth-canals-surface-column">
                      <ng-template #surface let-row>
                        <div *ngIf="row.model.enumToothSurfaceID" data-cy="teeth-canals-surface-container-{{row.index}}">

                          <mat-form-field class="dropdown-list" floatLabel="never" data-cy="teeth-canals-surface-field-{{row.index}}">
                            <mat-label data-cy="teeth-canals-surface-label-{{row.index}}">Surface</mat-label>
                            <mat-select [(value)]="row.model.enumToothSurfaceID" (selectionChange)="onChangeSurface($event); configurationService.setDirty();" data-cy="teeth-canals-surface-select-{{row.index}}">
                              <mat-option *ngFor="let enum of enumSurfaces" [value]="enum.ValidValueItemId" data-cy="teeth-canals-surface-option-{{enum.ValidValueItemId}}">
                                {{ enum.ItemDisplayValue }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>

                        </div>
                      </ng-template>
                    </tdo-table-column>
                    <tdo-table-column displayName="" propertyName="Remove" [rowTemplate]="remove" data-cy="teeth-canals-surface-remove-column">
                      <ng-template #remove let-row>
                        <div style="text-align: right;" data-cy="teeth-canals-surface-remove-container-{{row.index}}">
                          <button mat-icon-button [matTooltip]="'Remove Surface'" (click)="row.model.isDelete = true; removeSurface(row.model.ToothSurfaceId)" data-cy="teeth-canals-surface-remove-button-{{row.index}}"><mat-icon>delete</mat-icon></button>
                        </div>
                      </ng-template>
                    </tdo-table-column>
                  </tdo-table>

                </div>

                <button class="tdo-button tdo-save" style="margin-top:15px"
                        (click)="addSurface()" data-cy="teeth-canals-add-surface-button">Add Surface</button>

              </mat-tab>
            </mat-tab-group>

          </div>

        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>
